import React, { useState } from "react";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";
import styles from "./Dropdown.module.sass";
import Icon from "../../../components/Icon";
import moment from "moment"


const Dropdown = ({ className, value, setValue, options,oncheckNetworkfunction }) => {
  const [visible, setVisible] = useState(false);

  const handleClick = (value) => {
     setValue(value);
     setVisible(false); 
    
    oncheckNetworkfunction(value)
   
        
   
  };

  return (
    <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
      <div
        className={cn(styles.dropdown, className, { [styles.active]: visible })}
      >
        <div className={styles.head} onClick={() => setVisible(!visible)} style={{backgroundColor:"",width:"250px"}}>
          <div className={styles.selection} >{value}</div>
          <div className={styles.arrow}>
            <Icon name="arrow-bottom" size="10" />
          </div>
        </div>
        <div className={styles.body} style={{backgroundColor:"",width:"250px"}}>
          {options.map((x, index) => (
            <div
              className={cn(styles.option, {
                [styles.selectioned]: x === value,
              })}
              onClick={() => handleClick(x, index)}
              key={index}
            >
              {x}
            </div>
          ))}
        </div>
      </div>
    </OutsideClickHandler>
  );
};

export default Dropdown;
